import { CROWDING_EXTRACTION_VALUES } from 'constants/prescriptionOptions';
import { TreatmentPLanPreferenceFormType } from 'types/Settings.types';
import { TpvApiInput, TPVFormTypes } from 'types/TPVForm.types';
import { UltraTreatmentSpecType } from 'types/UltraPrescription.types';
import { ZenClearUltraApiInput } from 'types/ZenClearUltraApiInput.types';

import { buildUltraTpvPayload } from './ultraPrescription.payload.utils';
import { formatTeeth } from './ultraPrescription.teeth.utils';

export {
  convertToOptionsType,
  getStringValue,
  getSubOptionFromList,
  isOptionSelected,
  isOtherOptionSelected
} from './ultraPrescription.shared';
export {
  formatTeeth,
  formatTeethsForController,
  getToothChartValues,
  isFormattedTeethString,
  isPrimaryTeethString,
  splitTeethOrTextField
} from './ultraPrescription.teeth.utils';
export {
  getSagittalRelationshipData,
  getSagittalTreatmentOptions
} from './ultraPrescription.sagittal.utils';
export {
  getCrowdingSubOptions,
  mapAuxiliariesAndAppliancesForApi
} from './ultraPrescription.payload.utils';
export {
  formatUltraForForm,
  getDefaultZenClearUltraTreatmentSpec
} from './ultraPrescription.form.utils';

export const getZenClearUltraDataForTreatmentSpec = (
  isTreatmentTypeChanged: boolean,
  ClinicalPreferencesData: TreatmentPLanPreferenceFormType,
  data?: UltraTreatmentSpecType
): TpvApiInput => {
  const others = ClinicalPreferencesData?.ZenClearUltra?.others;
  const ultraPayload: ZenClearUltraApiInput = {
    ...buildUltraTpvPayload({ treatmentSpecifications: data }),
    specialNotes: data?.specialNotes,
    translatedSpecialNotes: data?.translatedSpecialNotes,
    type: TPVFormTypes.ZENCLEAR_ULTRA,
    clinicalPreferences: isTreatmentTypeChanged ? {} : others ? { others } : {},
    ...(data?.extraction?.Extraction === CROWDING_EXTRACTION_VALUES.EXTRACTION
      ? {
          teethToExtract: formatTeeth(data?.extraction?.toothChart)
        }
      : {})
  };
  return ultraPayload;
};
